import { useState } from 'react';
import styles from './CategoriesAndSkillsDesktop.module.css';
import { LeftCategories } from '../LeftCategories';
import { SkillsColumns } from '../SkillsColumns';

interface CategoryItem {
  label: string;
  href?: string;
  active?: boolean;
}

interface SkillColumn {
  title: string;
  skills: string[];
}

interface CategoriesAndSkillsDesktopProps {
  items: CategoryItem[];
  skills: SkillColumn[][];
}

export const CategoriesAndSkillsDesktop: React.FC<
  CategoriesAndSkillsDesktopProps
> = ({ items, skills }) => {
  const [selectedCategory, setSelectedCategory] = useState(0);

  // Handle category selection
  const handleCategorySelect = (
    item: { label: string; href?: string; active?: boolean },
    index: number
  ) => {
    setSelectedCategory(index);
  };

  return (
    <div className={styles.categoriesAndSkillsContainer}>
      <LeftCategories items={items} onCategorySelect={handleCategorySelect} />
      <SkillsColumns columns={skills[selectedCategory] || []} />
    </div>
  );
};
